import React, { useState, useEffect } from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import {
    CircularProgressbar,
    buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

// Animation
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "../../../utils/AnimatedProgressProvider";

import { Link, useNavigate } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import PhoneInput, { parsePhoneNumber, getCountryCallingCode } from 'react-phone-number-input'

import 'react-international-phone/style.css';
import { useDispatch, useSelector } from 'react-redux'
import { getCityData, getCountryData, getHomeCategoryData, getProfileData, getStateData, getSubCategoryData } from '../../../Redux/action/MasterAction';
import { getTutorGroupCategoryData, getTutorOneCategoryData, getTutorOneSubCategoryData, getTutorGroupSubCategoryData } from '../../../Redux/action/TutorAction';

import Beatloader from '../../../Common/BeatLoader';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import HourglassLoader from '../../../Common/HourglassLoader';

const host = process.env.REACT_APP_API_SERVER
const TutorProfileTeachingList = () => {
    const [showModal, setShowModal] = useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [catOther, setcatOther] = useState(false);
    const [subcatOther, setsubcatOther] = useState(false);
    const [isChecked, setIsChecked] = useState(true); // Boolean to track selected state

    const handleOneCheckChange = () => {
        setIsChecked(true);
        formik.setFieldValue("teaching_type", '0');
    };

    const handleGroupCheckChange = () => {
        setIsChecked(false);
        formik.setFieldValue("teaching_type", '1');
    };


    useEffect(() => {


        dispatch(getHomeCategoryData())

    }, [])

    const authToken = localStorage.getItem('tutor-token');
    useEffect(() => {
        dispatch(getProfileData(authToken))
    }, []);

    const {
        loadingProfileDataListApi,
        ProfileDataListApiData,
        ProfileDataListApiError,

        loadingCategoryDataListApi,
        CategoryDataListApiData,
        CategoryDataListApiError,

        loadingSubCategoryListApi,
        SubCategoryListApiData,
        SubCategoryListApiError,

    } = useSelector(state => state?.MasterReducer);






    const formik = useFormik({
        initialValues: {
            category_id: "",
            other_class_name: "",
            sub_category_id: "",
            other_subject_name: "",
            teaching_type: "0",
        },
        validationSchema: Yup.object().shape({

            category_id: Yup.string().required('Class/Grade/General/College/General is required'),
            sub_category_id: Yup.string().required('Subject is required'),
            other_class_name: catOther ? Yup.string().required('Class/Grade/General/College/General is required') : Yup.string(),
            other_subject_name: subcatOther ? Yup.string().required('Subject is required') : Yup.string()


        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {

            try {

                setSubmitting(true);
                let config = {
                    headers: {


                        "x-auth-token": localStorage.getItem('tutor-token'),
                    },
                };

                if (values.other_class_name == "") {
                    values.other_class_name = "0"
                }
                if (values.other_subject_name == "") {
                    values.other_subject_name = "0"
                }

                axios.post(`${host}/api/tutor/${values.teaching_type == '0' ? 'create-teaching-details-one-to-one' : 'create-teaching-details-group-tutoring'}`, values, config)

                    .then(res => {

                        if (res.status == 200) {

                            toast.success('Teaching details will be added after admin approval');
                            setSubmitting(false);
                            resetForm();
                            setIsChecked(true);
                            setShowModal(false);
                            setcatOther(false);
                            setsubcatOther(false);
                            dispatch(getProfileData(authToken));
                            navigate('/tutor/profile-settings');

                        } else {

                            toast.error(res.data.message);
                            setSubmitting(false);
                        }
                    }).catch(err => {
                        // console.log('error', err)

                        toast.error(err.response.data.message);

                        setSubmitting(false);
                    });

            }
            catch (error) {

                // console.log(error);
                toast.error(error.response.data.message);
                setSubmitting(false);

            }

        }
    });

    useEffect(() => {
        if (!showModal) {
            formik.setFieldValue('category_id', '')
            formik.setFieldValue('sub_category_id', '')
            formik.setFieldValue('other_class_name', '')
            formik.setFieldValue('other_subject_name', '')
            formik.setFieldValue('teaching_type', '0')

            setIsChecked(true);
            setcatOther(false);
            setsubcatOther(false);
        }
    }, [showModal])


    const handleCategoryChange = (e) => {
        const id = e.target.value
        formik.setFieldValue('sub_category_id', '')
        if (id == '0') {
            setcatOther(true);

            dispatch(getSubCategoryData('0'))
        }
        else if (id == '') {
            setcatOther(false)
            dispatch(getSubCategoryData('0'))
        }
        else {
            setcatOther(false)
            dispatch(getSubCategoryData(id))
        }
    }

    const handleSubCategoryChange = (e) => {
        const id = e.target.value
        if (id == '0') {
            setsubcatOther(true)
        }
        else {
            setsubcatOther(false)

        }

    }



    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Profile
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">

                            <main className="px-3 py-4">

                                <ul className="nav nav-tabs tutor-profile-tabs" id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="personal-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#personal"
                                            type="button"
                                            role="tab"
                                            aria-controls="personal"
                                            aria-selected="false"
                                        >
                                            <i className="fa-regular fa-user" /> Personal Information
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="bank-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#bank"
                                            type="button"
                                            role="tab"
                                            aria-controls="bank"
                                            aria-selected="true"
                                        >
                                            <i className="fa-solid fa-building-columns" /> Bank Details
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="price-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#price"
                                            type="button"
                                            role="tab"
                                            aria-controls="price"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-tag" /> Updated Tutoring Price
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active"
                                            id="tutor-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#tutor"
                                            type="button"
                                            role="tab"
                                            aria-controls="tutor"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-person-vcard-fill" /> Tutor Teaching List
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="cip-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#cip"
                                            type="button"
                                            role="tab"
                                            aria-controls="cip"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-person-fill-check" /> Cip Details
                                        </button>
                                    </li>
                                </ul>
                                <div
                                    className="tab-content"
                                    id="myTabContent"
                                    style={{ backgroundColor: "aliceblue" }}
                                >
                                    {/* Personal Information */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="personal"
                                        role="tabpanel"
                                        aria-labelledby="personal-tab"
                                    >
                                        <form>
                                            <div className="d-flex justify-content-between my-4">
                                                <h5>Personal Information</h5>
                                                <Link
                                                    to="/tutor/profile-settings-personal-info"
                                                    className="btn btn-primary edit-btn"
                                                >
                                                    <i className="bi bi-pencil-square" />
                                                    &nbsp;Edit
                                                </Link>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 mb-2 w-100 d-flex justify-content-center pt-5">
                                                    <div className="profile-top-sec w-50">
                                                        <div className="profile-top-img d-flex justify-content-center">
                                                            <OverlayTrigger

                                                                placement='right'
                                                                overlay={
                                                                    <Tooltip className='bg-light'>
                                                                        {ProfileDataListApiData?.profile_status_percentage}%
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className="img-sec position-relative">
                                                                    {/* Circular Progress Bar */}
                                                                    <AnimatedProgressProvider
                                                                        valueStart={0}
                                                                        valueEnd={ProfileDataListApiData?.profile_status_percentage}
                                                                        duration={1.4}
                                                                        easingFunction={easeQuadInOut}

                                                                    >
                                                                        {value => {
                                                                            const roundedValue = Math.round(value);
                                                                            return (
                                                                                <CircularProgressbar
                                                                                    value={value}

                                                                                    /* This is important to include, because if you're fully managing the
                                                                              animation yourself, you'll want to disable the CSS animation. */
                                                                                    styles={buildStyles({ pathTransition: "none" })}
                                                                                />
                                                                            );
                                                                        }}
                                                                    </AnimatedProgressProvider>
                                                                    {/* Profile Image */}
                                                                    <img
                                                                        src={`${host}${ProfileDataListApiData?.data?.profile_img}`}

                                                                        onError={(e) => {
                                                                            e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                        }}
                                                                        className="profile-img"
                                                                    />
                                                                </div>
                                                            </OverlayTrigger>
                                                        </div>
                                                        <h4 className="text-center mt-3">{ProfileDataListApiData?.data?.name}</h4>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Full Name
                                                    </label>


                                                    <p className=" input-form bg-white">{ProfileDataListApiData?.data?.name}</p>

                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Phone Number
                                                    </label>
                                                    <p className=" input-form bg-white">
                                                        {ProfileDataListApiData?.data?.country_code} {ProfileDataListApiData?.data?.mobile}

                                                    </p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Email ID
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.email}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Date of Birth
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.dob}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Gender
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.gender}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Address Line-1
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.address_line_1}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Address Line-2
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.address_line_2}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Country
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.countries?.name}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        State
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.states?.name}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        City
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.cities?.name}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Zip code
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.zip_code}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Qualification
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.qualifications}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Specialization
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.specialization}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Experience in years
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.experience}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Tutoring location
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.tutoring_location}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Session Price One to One
                                                    </label>
                                                    <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_one_to_one}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Session Price Group
                                                    </label>
                                                    <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_group}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Instructor Language
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.language}</p>
                                                </div>
                                                <div className="col-lg-12 col-md-12">
                                                    <label htmlFor="" className="label">
                                                        About the tutor
                                                    </label>

                                                    <textarea
                                                        className="input-form w-100 rounded"
                                                        readOnly
                                                        defaultValue={ProfileDataListApiData?.data?.tutordetails?.about_the_tutor}
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    {/* Bank Details */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="bank"
                                        role="tabpanel"
                                        aria-labelledby="bank-tab"
                                    >
                                        <form>
                                            <div className="d-flex justify-content-between my-4">
                                                <h5>Bank Details</h5>
                                                <Link
                                                    to="/tutor/profile-settings-bank-details"
                                                    className="btn btn-primary edit-btn"
                                                >
                                                    <i className="bi bi-pencil-square" />
                                                    &nbsp;Edit
                                                </Link>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Account Holder <span className='text-danger'>*</span>
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutorbankdetails?.account_holder}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Account Number<span className='text-danger'>*</span>
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutorbankdetails?.account_number}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                    SWIFT/BIC Code<span className='text-danger'>*</span>
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutorbankdetails?.wire_transfer_no}</p>
                                                </div>
                                                {/* <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        SWIFT/BIC Code<span className='text-danger'>*</span>
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutorbankdetails?.bank_code}</p>
                                                </div> */}
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Routing Number(ACH or ABA)<span className='text-danger'>*</span>
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutorbankdetails?.routing_no}</p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    {/* Updated Tutoring Price */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="price"
                                        role="tabpanel"
                                        aria-labelledby="price-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>Updated Tutoring Price</h5>
                                            <Link
                                                to="/tutor/profile-settings-updated-tutoring-price"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <label htmlFor="" className="label">
                                                    Session Price One To One<span className='text-danger'>*</span>
                                                </label>
                                                <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_one_to_one}</p>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <label htmlFor="" className="label">
                                                    Session Price Group<span className='text-danger'>*</span>
                                                </label>
                                                <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_group}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Tutor Teaching List */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade show active p-3"
                                        id="tutor"
                                        role="tabpanel"
                                        aria-labelledby="tutor-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>Tutor Teaching List</h5>

                                        </div>
                                        {loadingProfileDataListApi ?
                                            <Beatloader />
                                            :
                                            <form onSubmit={formik.handleSubmit} method='post'>
                                                <div className="row">
                                                    {ProfileDataListApiData?.data?.tutorteachingdetails?.map((data) => (
                                                        <div className="col-lg-6 col-md-6 mb-4">
                                                            <div className="tutor-teaching-list">
                                                                <div className="row">
                                                                    <div className="col-lg-3 col-md-3 d-flex align-item-center flex-wrap">
                                                                        <div
                                                                            className="initial-circle"
                                                                            style={{
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center',
                                                                                backgroundColor: '#f0f0f0',
                                                                                color: '#333',
                                                                                fontSize: '24px',
                                                                                fontWeight: 'bold',
                                                                                borderRadius: '50%',
                                                                                width: '80px',
                                                                                height: '80px',
                                                                                textTransform: 'uppercase',
                                                                            }}
                                                                        >
                                                                            {data?.sub_category?.name?.charAt(0) || '-'}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-6 col-md-5 pt-3">
                                                                        <h6 className=" tutor-teaching-list-h6">{data?.category?.other_name ? data?.category?.other_name : data?.category?.name}</h6>
                                                                        <p className=" tutor-teaching-list-eco mt-1">{data?.sub_category?.other_name ? data?.sub_category?.other_name : data?.sub_category?.name}</p>
                                                                        <p className=" tutor-teaching-list-group ">{data?.teaching_type_id ? 'Group' : 'One To One'}</p>
                                                                    </div>
                                                                    <div className="col-lg-3 col-md-4">
                                                                        <p className=" tutor-teaching-list-approve">{data?.status}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="row">
                                                    {/* <div className="col-lg-3 col-md-6 mb-3">
                                                        <input
                                                            disabled={formik.isSubmitting}
                                                            type="submit"
                                                            defaultValue="Submit"
                                                            id="submit-btn-four"
                                                            className="btn btn-primary input-form-submit submit-btn w-100"

                                                        />
                                                    </div> */}
                                                    <div className="col-lg-3 col-md-6 mb-3">
                                                        <button
                                                            type="button"
                                                            id="add-btn"
                                                            className="btn btn-primary w-100"
                                                            onClick={() => { setShowModal(true) }}

                                                        >
                                                            <i className="fa-solid fa-plus" />
                                                            &nbsp;Add
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        }
                                    </div>
                                    {/* Cip Details */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="cip"
                                        role="tabpanel"
                                        aria-labelledby="cip-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>Cip Details</h5>
                                            <Link
                                                to="/tutor/profile-settings-cip"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload educational document image</h5>

                                                    {ProfileDataListApiData?.data?.tutorkycdetails?.educational_degree &&
                                                        <div className="image-preview" id="imagePreview">
                                                            <img
                                                                id="preview"
                                                                width={100}
                                                                src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.educational_degree}`}

                                                                onError={(e) => {
                                                                    e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                                }}
                                                                alt="Image Preview"

                                                            />
                                                        </div>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload certificate image</h5>

                                                    {ProfileDataListApiData?.data?.tutorkycdetails?.certification &&
                                                        <div className="image-preview" id="imagePreview">
                                                            <img
                                                                id="preview"
                                                                width={100}
                                                                src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.certification}`}

                                                                onError={(e) => {
                                                                    e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                                }}
                                                                alt="Image Preview"

                                                            />
                                                        </div>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload KYC document image</h5>

                                                    {ProfileDataListApiData?.data?.tutorkycdetails?.kyc_document &&
                                                        <div className="image-preview" id="imagePreview">
                                                            <img
                                                                id="preview"
                                                                width={100}
                                                                src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.kyc_document}`}

                                                                onError={(e) => {
                                                                    e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                                }}
                                                                alt="Image Preview"

                                                            />
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-12">
                                                <input
                                                    type="submit"
                                                    defaultValue="Submit"
                                                    className="btn btn-primary input-form-submit submit-btn w-100"
                                                    id="submit-btn-five"
                                                    style={{ display: "none" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>



                        </div>
                    </div>
                </div>
            </section>

            <>
                {/* Modal */}
                <Modal
                    className='modal'
                    show={showModal}
                    onHide={() => setShowModal(false)}
                >

                    <form onSubmit={formik.handleSubmit} >
                        <Modal.Header closeButton>
                            <h5 className="modal-title" id="exampleModalLabel">
                                Teaching Details
                            </h5>

                        </Modal.Header>
                        <Modal.Body >
                            <div className="row mb-2">
                                <div className="col-lg-6 my-2">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={isChecked} // Checkbox is selected when isChecked is true
                                                        onChange={handleOneCheckChange}
                                                    />
                                                </div>
                                                <div className="col-lg-9">
                                                    <img
                                                        src="/assets/img/user/one-to-one-img.png"
                                                        className="img-fluid"
                                                    />
                                                    <h6 className="mb-0">One To One</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 my-2">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={!isChecked} // Checkbox is selected when isChecked is false
                                                        onChange={handleGroupCheckChange}
                                                    />
                                                </div>
                                                <div className="col-lg-9">
                                                    <img
                                                        src="/assets/img/user/group-img.png"
                                                        className="img-fluid"
                                                    />
                                                    <h6 className="mb-0">Group Tutoring</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12 mb-2">
                                    <label htmlFor="" className="label">
                                        Select Class/Grade/General/College/General <span className='text-danger'>*</span>
                                    </label>
                                    <br />
                                    <select className="select-form w-100 py-2"
                                        name="category_id"
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            handleCategoryChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.category_id}>
                                        <option value=''>-Select-</option>
                                        {
                                            CategoryDataListApiData?.map((data) => (
                                                <option value={data?.id}>{data?.name}</option>
                                            ))}
                                        <option value='0'>Others</option>
                                    </select>
                                    <div className="help-block with-errors">
                                        {formik.touched.category_id && formik.errors.category_id ? (
                                            <div className='text-danger'>{formik.errors.category_id}</div>
                                        ) : null}
                                    </div>
                                </div>
                                {catOther &&
                                    <>
                                        <div className="col-lg-12 mb-2">
                                            <label htmlFor="" className="label">
                                                Enter Class/Grade/General/College/General <span className='text-danger'>*</span>
                                            </label>
                                            <br />
                                            <input
                                                maxLength={30}
                                                className='input-form'
                                                type="text"
                                                name="other_class_name"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.other_class_name}
                                            />
                                        </div>
                                        <div className="help-block with-errors">
                                            {formik.touched.other_class_name && formik.errors.other_class_name ? (
                                                <div className='text-danger'>{formik.errors.other_class_name}</div>
                                            ) : null}
                                        </div>
                                    </>
                                }
                                <div className="col-lg-12 mb-2">
                                    <label htmlFor="" className="label">
                                        Select Subject<span className='text-danger'>*</span>
                                    </label>
                                    <br />
                                    <select className="select-form w-100 py-2"
                                        name="sub_category_id"
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            handleSubCategoryChange(e);

                                        }}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.sub_category_id}>
                                        <option value=''>-Select-</option>
                                        {
                                            SubCategoryListApiData?.map((data) => (
                                                <option value={data?.id}>{data?.name}</option>
                                            ))}
                                        <option value='0'>Others</option>

                                    </select>
                                    <div className="help-block with-errors">
                                        {formik.touched.sub_category_id && formik.errors.sub_category_id ? (
                                            <div className='text-danger'>{formik.errors.sub_category_id}</div>
                                        ) : null}
                                    </div>
                                </div>
                                {subcatOther &&
                                    <>
                                        <div className="col-lg-12 mb-2">
                                            <label htmlFor="" className="label">
                                                Enter Subject <span className='text-danger'>*</span>
                                            </label>
                                            <br />
                                            <input type="text"
                                                maxLength={30}
                                                className='input-form'
                                                name="other_subject_name"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.other_subject_name}
                                            />
                                        </div>
                                        <div className="help-block with-errors">
                                            {formik.touched.other_subject_name && formik.errors.other_subject_name ? (
                                                <div className='text-danger'>{formik.errors.other_subject_name}</div>
                                            ) : null}

                                        </div>
                                    </>
                                }
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <button type="submit" disabled={formik.isSubmitting} className="btn btn-primary"  style={{width:'min-content'}}>

                                {formik.isSubmitting ? <HourglassLoader /> : 'Continue'}
                            </button>
                        </Modal.Footer>
                    </form>

                </Modal>
            </>

        </div>
    )
}

export default TutorProfileTeachingList